import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CabeceraModule } from "../../../components/common/cabecera/cabecera.module";
import { SegurosContratados } from "./seguros-contratados.component";
import { SegurosContratadosService } from "./seguros-contratados.service";
import { UtilService } from "../../../components/common/utils/util.service"
import { DataTableModule } from "angular2-datatable";
import { DatosGeneralesService } from "../datosGenerales/datos-generales.service";
import { ConsultarUsuarioMasivos } from "../../../components/common/utils/consultarUsuarioMasivos";
import { Ng2Bs3ModalModule } from "ng2-bs3-modal/ng2-bs3-modal";
import { RenovacionModule } from "../renovaciones/renovacion.module";
import { Ng2Webstorage } from "ngx-webstorage";
import { CancelacionModule } from "../cancelaciones/cancelacion.module";
import { CalendarModule } from 'primeng/primeng';
import { SiniestrosModule } from "../../siniestros/siniestros.model";
import { ApplicationPipesModule } from "../../../components/pipes/safe.module";

@NgModule({
    declarations: [SegurosContratados],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        CabeceraModule,
        DataTableModule,
        Ng2Bs3ModalModule,
        RenovacionModule,
        CancelacionModule,
        Ng2Webstorage,
        CalendarModule,
        SiniestrosModule,
        ApplicationPipesModule
    ],
    providers: [SegurosContratados, UtilService, DatosGeneralesService, ConsultarUsuarioMasivos]
})

export class SegurosContratadosModule { }



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/segurosContratados/seguros-contratados.module.ts